{
  "name": "pulse-client",
  "version": "2.219.4",
  "description": "Pulse Client",
  "author": "WorkTango <info@worktango.io> (https://worktango.com)",
  "type": "module",
  "repository": {
    "type": "git",
    "url": "git@github.com:KazooHR/pulse-web.git"
  },
  "license": "UNLICENSED",
  "private": true,
  "scripts": {
    "build-fragment": "node src/_graphql/schema/schemaQuery.js",
    "build:feature-flags": "cd ../../.. && yarn build --filter=@worktango/feature-flags-react",
    "build": "yarn codegen:cached && ../../../node_modules/typescript-native/bin/tsc -b && cross-env NODE_OPTIONS=--max-old-space-size=8192 vite build",
    "preview": "vite preview",
    "codegen": "cd codegen && graphql-codegen -r ts-node/register/transpile-only --config codegen.ts",
    "codegen:cached": "cd ../../.. && yarn codegen --filter=pulse-client",
    "dev": "yarn codegen:cached && yarn build:feature-flags && vite",
    "dev:quick": "vite",
    "format:check": "prettier --cache --ignore-unknown --check './**'",
    "format": "prettier --cache --ignore-unknown -l --write './**'",
    "lint:fix": "eslint --fix --cache --max-warnings 0 --no-warn-ignored",
    "lint": "eslint .",
    "test:ci": "cross-env CI=TRUE ../../../node_modules/.bin/vitest run --coverage --reporter default --reporter junit",
    "test:ci:changed": "cross-env CI=TRUE ../../../node_modules/.bin/vitest run --coverage --reporter default --reporter junit --changed develop",
    "test": "../../../node_modules/.bin/vitest",
    "test:changed": "../../../node_modules/.bin/vitest --changed",
    "test:coverage": "../../../node_modules/.bin/vitest --changed --coverage",
    "test:ui": "../../../node_modules/.bin/vitest --ui --changed --coverage",
    "test:leaks": "../../../node_modules/.bin/vitest --changed --detect-async-leaks"
  },
  "dependencies": {
    "@apollo/client": "3.11.4",
    "@datadog/browser-rum": "7.1.0",
    "@date-io/date-fns": "1.3.13",
    "@dnd-kit/core": "^6.2.0",
    "@dnd-kit/sortable": "^9.0.0",
    "@emotion/react": "^11.13.0",
    "@emotion/styled": "^11.13.0",
    "@mui/icons-material": "^5.15.10",
    "@mui/material": "^5.15.19",
    "@mui/x-charts": "^7.16.0",
    "@mui/x-date-pickers": "^6.19.4",
    "@reduxjs/toolkit": "1.9.7",
    "@tanstack/react-query": "^5.40.0",
    "@tanstack/react-query-devtools": "^5.40.0",
    "@worktango/ai-assistant": "0.0.133",
    "@worktango/employee-import-pipeline": "*",
    "@worktango/employee-import-validation": "*",
    "@worktango/feature-flags-react": "*",
    "@worktango/shared-frontend": "*",
    "@worktango/translations": "*",
    "apollo-upload-client": "^12.1.0",
    "apollo3-cache-persist": "0.14.0",
    "chart.js": "2.9.4",
    "chartjs-plugin-datalabels": "0.7.0",
    "classnames": "2.3.1",
    "date-fns": "2.23.0",
    "date-fns-tz": "1.2.2",
    "dexie": "3.2.2",
    "dom-to-image-more": "^3.4.5",
    "dotenv": "16.0.3",
    "graphql": "16.9.0",
    "i18next": "21.5.2",
    "localforage": "^1.9.0",
    "lodash.debounce": "4.0.8",
    "lodash.orderby": "4.6.0",
    "lodash.uniqby": "4.7.0",
    "normalizr": "^3.6.1",
    "pptxgenjs": "3.11.0",
    "prop-types": "15.7.2",
    "qr-code-styling": "1.9.2",
    "qs": "6.15.2",
    "react": "18.2.0",
    "react-color": "2.17.3",
    "react-dom": "18.2.0",
    "react-error-boundary": "^4.0.13",
    "react-hook-form": "^5.7.2",
    "react-i18next": "11.18.6",
    "react-quill": "^2.0.0",
    "react-redux": "^8.0.5",
    "react-router-dom": "^6.30.3",
    "react-select": "^1.0.0",
    "react-virtualized": "^9.22.5",
    "react-virtualized-select": "3.1.3",
    "react-wordcloud": "^1.2.5",
    "redux": "^4.2.1",
    "redux-logger": "^3.0.6",
    "tss-react": "^4.9.21",
    "validator": "13.15.26",
    "whatwg-fetch": "^3.5.0",
    "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz",
    "yaml": "2.8.3",
    "zustand": "^5.0.14",
    "zxcvbn": "^4.4.2"
  },
  "devDependencies": {
    "@eslint/js": "^9.17.0",
    "@graphql-codegen/cli": "*",
    "@graphql-codegen/typescript": "*",
    "@graphql-codegen/typescript-operations": "*",
    "@graphql-codegen/typescript-react-apollo": "*",
    "@testing-library/dom": "10.4.1",
    "@testing-library/jest-dom": "6.9.1",
    "@testing-library/react": "16.3.0",
    "@types/lodash.debounce": "4.0.7",
    "@types/qs": "^6.9.8",
    "@types/react": "18.2.79",
    "@types/react-dom": "18.2.25",
    "@vitejs/plugin-react": "^6.1.0",
    "@vitest/coverage-istanbul": "4.1.1",
    "@vitest/coverage-v8": "^4.1.0",
    "@vitest/ui": "^4.1.0",
    "@welldone-software/why-did-you-render": "^8.0.3",
    "cross-env": "6.0.3",
    "eslint": "^9.17.0",
    "eslint-plugin-react-hooks": "^5.0.0",
    "eslint-plugin-react-refresh": "^0.4.16",
    "globals": "^15.14.0",
    "happy-dom": "^20.0.2",
    "husky": "^8.0.0",
    "msw": "^2.11.1",
    "node-fetch": "^2.6.0",
    "prettier": "3.3.3",
    "ts-node": "10.9.1",
    "typescript": "5.6.3",
    "typescript-eslint": "^8.18.2",
    "typescript-native": "npm:typescript@7.0.2",
    "vite": "^8.2.2",
    "vite-plugin-graphql-loader": "5.1.1",
    "vite-plugin-svgr": "^5.2.0",
    "vitest": "^4.1.0"
  },
  "overrides": {
    "webpack": "4.44.2"
  },
  "browserslist": [
    ">0.2%",
    "not dead",
    "not op_mini all"
  ],
  "msw": {
    "workerDirectory": "public"
  },
  "lint-staged": {
    "./**/*.{js,ts,tsx,jsx}": [
      "yarn lint:fix",
      "yarn format"
    ],
    "./**/*.json": [
      "yarn format"
    ]
  }
}
